import * as React from "react";
import { Typography, Container } from "@mui/material";
import "./reviewAria.css";
import { Link } from "react-router-dom";
import myCourses from "../../assets/images/myCourses.png";
import TopCourseBg from "../../assets/images/top_course_bg.png";
import AliceCarousel from "react-alice-carousel";
import LessionIcon from "../../assets/images/lession.png";
import TotalEnrolledIcon from "../../assets/images/total-enrolled.png";
import getTopCourseApi from "../../apis/api/TopCourses";
import Rating from "@mui/material/Rating";
import feed1 from "../../assets/images/studentsImages/feedback1.jpg";
import feed2 from "../../assets/images/studentsImages/feedback2.jpg";
import feed3 from "../../assets/images/studentsImages/feedback3.jpeg";
import feed4 from "../../assets/images/studentsImages/feedback4.jpg";
import feed5 from "../../assets/images/studentsImages/feedback5.jpeg";
import feed6 from "../../assets/images/studentsImages/feedback6.jpeg";
import feed7 from "../../assets/images/studentsImages/feedback7.jpg";
import feed8 from "../../assets/images/studentsImages/feedback8.JPG";
import feed9 from "../../assets/images/studentsImages/feedback9.jpg";
import feed10 from "../../assets/images/studentsImages/feedback10.jpg";
import feed11 from "../../assets/images/studentsImages/feedback11.jpg";
import feed12 from "../../assets/images/studentsImages/feedback12.png";
//import {AnimatePresence, motion} from 'framer-motion';
//import { useIsMobile } from "../../utils/mobileScreen";
const responsive = {
    400: { items: 1 },
    568: { items: 1 },
    1024: { items: 1 },
};

const studentSays = [
    {
      pic: feed1,
      title: "Siva Teja Pottella",
      destination: "Java",
      overview:
        "The instructor was very articulate and just knew what and how to teach. The course material was quite relevant and rich with a good mix of projects and assignments.",
    },
    {
      pic: feed2,
      title: "Rushali Kashyap",
      destination: "Android Development",
      overview:
        "I was looking for a course that could transform my interest in Android Development into educational and professional advancement. With Techvanto Academy’s certification course, I got exactly what I was looking for!",
    },
    {
      pic: feed3,
      title: "John Junior",
      destination: "Cyber Forensics",
      overview:
        "Considering my needs and experience, every class was so frictionless that it left me super-pumped up for the next one.",
    },
    {
      pic: feed4,
      title: "Vishal Goyal",
      destination: "Node",
      overview:
        "I really appreciate the self-paced, comprehensive structure of the course since I was able to pursue it alongside my work schedule.",
    },
    {
      pic: feed5,
      title: "Rudra Prasada Rao",
      destination: "VLSI",
      overview:
        "I enrolled in the VLSI training that helped me build my technical skills, gain knowledge and grow in this field. It was well suited for me even as a complete beginner in the field.",
    },
    {
      pic: feed6,
      title: "Yalamati Jnana Sahiti",
      destination: "VLSI",
      overview:
        "I loved the flow of the VLSI training course, whatever was taught in the lectures was evaluated in projects and assignments.",
    },
    {
      pic: feed7,
      title: "Akshita Saini",
      destination: "Cyber Forensics",
      overview:
        "For a beginner like me, Techvanto Academy's courses are an absolute treat with easy-to-understand modules and apt expert guidance. I recently enrolled in the Cyber Security course  pursuing the Cyber Forensics course.",
    },
    {
      pic: feed8,
      title: "Gunduka Srinivas",
      destination: "Full Stack Development",
      overview:
        "I have browsed several courses on Full Stack Web Development. However, Techvanto Academy’s Full Stack Web Dev course struck me differently with an experienced and humble instructor who provided valuable additional inputs during the course.",
    },
    {
      pic: feed9,
      title: "Sai Kumar",
      destination: "Python",
      overview:
        "The Python Programming course transformed me from an amateur in programming to someone who is able to program with ease. Thanks to the wonderful instructor.",
    },
    {
      pic: feed10,
      title: "Anjali Sharma",
      destination: "Data Science",
      overview:
        "My experience with the course was amazing. Well-structured course, expert guidance and practical knowledge-I found everything to the point.",
    },
    {
      pic: feed11,
      title: "Krishna Vardhan",
      destination: "Python",
      overview:
        "I got a perfect head-start to my career after I attended one of Techvanto Academy’s training programs on Python. I would recommend it to anyone who is figuring out how to get into the field of programming.",
    },
    {
      pic: feed12,
      title: "Abhilash Sathavelly",
      destination: "VLSI",
      overview:
        "The VLSI Course is a very hands-on course, there was no dawdle at all. Highly recommended for all fellow students.",
    },
  ];
const ReviewAria = () => {
  //const isMobile = useIsMobile();
  const [topCourses, setTopCourses] = React.useState([]);
  const itemData = [
    {
      pic: myCourses,
      title1: "Sr. Full Stack Developer",
      title2: "Verizon Data Services",
      author: "Deepa Paikar",
    },
    {
      pic: myCourses,
      title1: "Software Engineer",
      title2: "Salesforce",
      author: "Anoosha Chandra",
    },
    {
        pic: myCourses,
        title1: "Software Engineer",
        title2: "Salesforce",
        author: "Anoosha Chandra",
      }
    ]
  
  React.useEffect(async () => {
    getTopCourse()
  },[])
  const getTopCourse = async() => {
    await getTopCourseApi(setTopCourses);
  }

  let items = studentSays.map((data, index) => (
    <TopCoursesData data={data} key={index}></TopCoursesData>
  ));

  return (
    <section>
      <Container className="admin-aria-container top-courses-box">
        <div className="top-courses-aria review-aria">
            <div className="revew-main-box">
                <div>
                    <Typography component="h2" className="techvanto-whyus-heading review-heading-text">
                      What our students says about us?
                    </Typography>
                    <p className="r-text-desc">
                      Our success has been driven by our many learners. Hear what they have to say about their experiences with Techvanto.
                    </p>
                </div>
                <div className="revew-car-aria">
                    <AliceCarousel
                        className="techvanto-student-says-carousel"
                        responsive={responsive}
                        autoPlayDirection={"rtl"}
                        autoPlayStrategy={"none"}
                        animationEasingFunction={"ease"}
                        autoPlay={false}
                        controlsStrategy="alternate"
                        infinite={true}
                        mouseTracking
                        items={items}
                        renderPrevButton={() => {
                            return <div className="left-arrow-studentSays">◄</div>;
                        }}
                        renderNextButton={() => {
                            return <div className="right-arrow-studentSays">►</div>;
                        }}
                    />
                </div>
            </div>
            
        </div>
      </Container>
    </section>
  );
};
const TopCoursesData = (props) => {
    return (
        <main className="main">
          <section className="container">
            <article className="review r-card">
                <div style={{position: 'relative'}}>
                    <div style={{
                      backgroundColor: 'var(--color-grey-box)',
                      borderRadius: '8px',
                      padding: '4px'
                    }} className="r-pic-aria">
                      <img src={props.data.pic} 
                        className='r-client-pic'
                        style={{
                            borderRadius: '8px'
                        }} />
                    </div>
                    <div className="revew-details">
                        <div style={{
                            borderLeft: '2px solid var(--color-black)',
                            paddingLeft: '20px'
                        }}>
                            <p className="r-description">"{props.data.overview}"</p>
                            <p style={{
                                fontWeight: 'bold',
                                color: 'var(--color-black)',
                                marginBottom: 0
                            }}>{props.data.title}</p>
                            <p style={{
                                fontSize: '12px'
                            }}>{props.data.destination}</p>
                        </div>
                    </div>
                </div>
            </article>
          </section>
        </main>
      );
}
export default ReviewAria;
